import React, { useState } from "react";
import DashboardCalendarDay from "./DashboardCalendarDay";

const DashboardCalendar = ({ eventos, onDayClick  }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const getDaysInMonth = (month, year) =>
    new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();

  const handleMonthChange = (direction) => {
    let newMonth = currentMonth + direction;
    let newYear = currentYear;

    if (newMonth < 0) {
      newMonth = 11;
      newYear--;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear++;
    }

    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
  };

  const renderCalendarDays = () => {
    const daysInMonth = getDaysInMonth(currentMonth, currentYear);
    const firstDayOfMonth = getFirstDayOfMonth(currentMonth, currentYear);
    const calendarDays = [];
  
    // Espacios vacíos antes del primer día del mes
    for (let i = 0; i < firstDayOfMonth; i++) {
      calendarDays.push(<div key={`empty-${i}`} className="h-16 w-16"></div>);
    }
  
    // Días del mes
    for (let day = 1; day <= daysInMonth; day++) {
      const fechaActual = new Date(currentYear, currentMonth, day)
        .toISOString()
        .split("T")[0]; // Formatear a YYYY-MM-DD
  
      // Filtrar eventos del día actual (también formateamos la fecha del evento)
      const eventosDelDia = eventos.filter((evento) => {
        const fechaEvento = new Date(evento.fecha).toISOString().split("T")[0];
        return fechaEvento === fechaActual;
      });
  
      calendarDays.push(
        <DashboardCalendarDay
          key={day}
          day={day}
          month={currentMonth}
          year={currentYear}
          eventosDelDia={eventosDelDia}
          onDayClick={onDayClick} // Pasamos la función al día
        />
      );
    }
  
    return calendarDays;
  };
  

  return (
    <div>
      {/* Header del calendario */}
      <div className="flex justify-between items-center mb-4">
        <button
          onClick={() => handleMonthChange(-1)}
          className="text-xl font-bold"
        >
          &lt;
        </button>
        <h2 className="text-xl font-semibold">
          {months[currentMonth]} {currentYear}
        </h2>
        <button
          onClick={() => handleMonthChange(1)}
          className="text-xl font-bold"
        >
          &gt;
        </button>
      </div>

      {/* Días del calendario */}
      <div className="grid grid-cols-7 gap-4 text-center">
        {["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"].map((day) => (
          <div key={day} className="text-sm font-semibold text-gray-600">
            {day}
          </div>
        ))}

        {renderCalendarDays()}
      </div>
    </div>
  );
};

export default DashboardCalendar;
